import { Outlet } from 'react-router-dom';
import { Header, Footer } from '@/components/layout';

/**
 * Main layout for public-facing pages
 * Includes header and footer with main content area
 */
export function MainLayout() {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
